import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const CONSENT_KEY = 'peak9_cookie_consent';

export const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleChoice = (choice) => {
    localStorage.setItem(CONSENT_KEY, choice);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-consent-banner"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4 }}
          className="fixed bottom-0 left-0 right-0 z-[90] bg-[#1F2A44] border-t border-[#F4F1EC]/10"
        >
          <div className="container-peak py-4 flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
            <p className="text-[#F4F1EC]/70 text-xs lg:text-sm flex-1 text-center sm:text-left">
              We use a few essential cookies to keep this site running. No tracking, no ads.{' '}
              <Link to="/cookie-policy" className="text-[#D97904] underline hover:text-[#D97904]/80">
                Learn more
              </Link>
            </p>
            <div className="flex items-center gap-3 shrink-0">
              <button
                data-testid="cookie-consent-decline-btn"
                onClick={() => handleChoice('declined')}
                className="text-[#F4F1EC]/50 text-xs uppercase tracking-[0.1em] font-['Syne'] hover:text-[#F4F1EC] transition-colors px-2"
              >
                Decline
              </button>
              <button
                data-testid="cookie-consent-accept-btn"
                onClick={() => handleChoice('accepted')}
                className="bg-[#D97904] text-white text-xs uppercase tracking-[0.1em] font-['Syne'] px-4 py-2 hover:bg-[#D97904]/90 transition-colors"
              >
                Got it
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsentBanner;
